import React from 'react';

import './StatCard.scss';

const StatCard = ({ prop, value, type }) => {
  const className = 'c-CreatorMasterCourseDarkVariant-StatCard';

  return (
    <div className={className}>
      <div className={`${className}__primary`}>{prop}</div>
      <div className={`${className}__secondary`}>
        {value}
        <span>{type}</span>
      </div>
    </div>
  );
};

export default StatCard;
